import { Link } from 'react-router-dom'
import './Footer.css'

export default function Footer() {
    const currentYear = new Date().getFullYear()

    return (
        <footer className="footer">
            <div className="footer-container container">
                <div className="footer-grid">
                    {/* Brand */}
                    <div className="footer-brand">
                        <Link to="/" className="footer-logo">
                            <span className="logo-icon">◆</span>
                            <span>SecondWorld</span>
                        </Link>
                        <p className="footer-tagline">
                            Premium corporate e-commerce platform delivering quality products worldwide.
                        </p>
                    </div>

                    {/* Quick Links */}
                    <div className="footer-section">
                        <h4 className="footer-title">Quick Links</h4>
                        <nav className="footer-nav">
                            <Link to="/products">Products</Link>
                            <Link to="/about">About Us</Link>
                            <Link to="/contact">Contact</Link>
                        </nav>
                    </div>

                    {/* Legal */}
                    <div className="footer-section">
                        <h4 className="footer-title">Legal</h4>
                        <nav className="footer-nav">
                            <Link to="/privacy">Privacy Policy</Link>
                            <Link to="/terms">Terms of Service</Link>
                            <Link to="/refund">Refund Policy</Link>
                        </nav>
                    </div>

                    {/* Contact */}
                    <div className="footer-section">
                        <h4 className="footer-title">Contact</h4>
                        <address className="footer-contact">
                            <p>support@secondworld.com</p>
                            <p>+1 (555) 123-4567</p>
                        </address>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="footer-bottom">
                    <p>&copy; {currentYear} SecondWorld. All rights reserved.</p>
                </div>
            </div>
        </footer>
    )
}
